/*
 * Public API Surface of ngx-skeleton-loader
 */

export * from './lib/ngx-skeleton-loader.component';
export * from './lib/ngx-skeleton-loader.module';
export * from './lib/ngx-skeleton-loader-config.types';
